// Array of all page section keys (used to validate the config setting)
export const HOTEL_DETAILS_PAGE_SECTION_KEYS = [
    'summary',
    'overview',
    'rooms',
    'offers',
    'flights',
    'map',
    'widgets',
    'calendar',
    'flightUpsell',
    'reviews',
];
// Default page section ordering for funnel
export const HOTEL_DETAILS_SECTION_ORDER_FUNNEL = [
    'summary',
    'calendar',
    'flightUpsell',
    'flights',
    'rooms',
    'overview',
    'reviews',
    'map',
];
// Default page section ordering for landing page
export const HOTEL_DETAILS_SECTION_ORDER_LP = [
    'summary',
    'offers',
    'calendar',
    'rooms',
    'overview',
    'reviews',
    'widgets',
    'map',
];
